const TABLE_HEAD_WIDTH = "40%";

const TABLE_CELL_WIDTH = { base: "180px", xl: "210px" };

export { TABLE_HEAD_WIDTH, TABLE_CELL_WIDTH };
